import React, { useEffect, useState } from "react";
import { gql, useLazyQuery, useMutation } from "@apollo/client";
import { useParams } from "react-router-dom";
import { Divider, Skeleton, Modal, Row, Col, Button, Image } from "antd";
import { useNavigate } from "react-router-dom";
import StrikethroughPrice from "@general/strikethroughPrice";
import { apiUrl } from "@utils/apoloClient";

export default function SingleConsultation() {
  const GETPRODUCT = gql`
    query ($id: ID!) {
      getProduct(id: $id) {
        id
        name
        description
        strikethroughRial
        amountRial
        image
      }
    }
  `;
  const REQUESTCONSULTATION = gql`
    mutation ($productId: ID!) {
      createConsultationInvoice(productId: $productId) {
        id
      }
    }
  `;
  const navigate = useNavigate();
  const { id } = useParams();
  const [consultationDetails, setConsultationsDtails] = useState({});
  const [getServiceData, serviceData] = useLazyQuery(GETPRODUCT, {
    fetchPolicy: "no-cache",
    onCompleted({ getProduct }) {
      setConsultationsDtails(getProduct);
    },
  });
  useEffect(() => {
    getServiceData({
      variables: {
        id,
      },
    });
  }, [id]);
  const [runRequestConsultation, requestConsultation] = useMutation(
    REQUESTCONSULTATION,
    {
      onError(err) {
        Modal.error({
          title: err.message,
          okText: "باشه",
        });
      },
      onCompleted(data) {
        navigate(`/invoice/${data.createConsultationInvoice.id}`);
      },
    }
  );

  const createInvoice = () => {
    runRequestConsultation({
      variables: {
        productId: id,
      },
    });
  };
  if (serviceData.loading)
    return (
      <div className="single-consultation-wrapper-loading">
        <Skeleton active round />
        <Skeleton active round />
      </div>
    );
  return (
    <>
      <div className="single-consultation-wrapper">
        <div className="single-consultation-content">
          <div className="single-consultation-name">
            مشاوره با {consultationDetails?.name}
          </div>
          {consultationDetails?.description && (
            <>
              <Divider orientation="right">توضیحات</Divider>
              <div className="single-consultation-description">
                {consultationDetails.description}
              </div>
            </>
          )}
          <Divider orientation="right">هزینه ی مشاوره</Divider>
          <div className="single-consultation-details">
            <Row gutter={20} style={{ width: "100%" }}>
              <Col xs={24}>
                <StrikethroughPrice
                  strikethroughRial={consultationDetails?.strikethroughRial}
                  amountRial={consultationDetails?.amountRial}
                />
              </Col>
            </Row>
          </div>
        </div>

        <div className="single-consultation-thumb">
          <Image width={300} src={`${apiUrl + consultationDetails?.image}`} />
        </div>
      </div>
      <div className="single-consultation-btn">
        <Button type="primary" onClick={createInvoice}>رزرو قرار ملاقات</Button>
      </div>
    </>
  );
}
